import { CustomStatusPanelProps } from 'ag-grid-react';
import { t } from 'i18next';
import { sum } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { IElement } from 'bom/types';
import { TotalPrice } from 'core/elements';
import { useAgGridClientTableContext } from 'core/states';

interface IProps extends CustomStatusPanelProps {
  totalLabel: string;
}

export const TotalsStatusBar = ({ totalLabel = t('labelTotal') }: IProps) => {
  const [totals, setTotalPrices] = useState<{ cost: number | undefined }>({
    cost: undefined,
  });

  const classNames = 'ag-status-name-value ag-status-panel';

  const { rows } = useAgGridClientTableContext();

  const calculateTotalCost = useCallback((records: IElement[]) => {
    const cost = sum(records.map((record) => record.quantity * record.cost)) || undefined;

    setTotalPrices({ cost });
  }, []);

  useEffect(() => {
    calculateTotalCost(rows as IElement[]);
  }, [calculateTotalCost, rows]);

  return <TotalPrice label={totalLabel} value={totals?.cost} options={{ classNames }} />;
};
